// 手机脱敏
export const replacePhone = (phone) => {
  return phone.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
}

// 身份证号码脱敏
export const replaceCard = (card) => {
  return card.replace(/(\w{6})\w*(\w{4})/, '$1********$2')
}
